import React from 'react'
import PropTypes from 'prop-types'

const days = [
    { label: 'Mon', value: 'monday' },
    { label: 'Tue', value: 'tuesday' },
    { label: 'Wed', value: 'wednesday' },
    { label: 'Thu', value: 'thursday' },
    { label: 'Fri', value: 'friday' },
    { label: 'Sat', value: 'saturday' },
    { label: 'Sun', value: 'sunday' }
]

const DaysList = (props) => {
    return days.map((item, key) => {
        return (
            <div
                key={key}
                className={`day-item ${props.selectedDays.includes(item.value) ? 'active' : ''}`}
                onClick={() => props.handleClick(item.value)}
            >{item.label}
            </div>
        )
    })
}

DaysList.propTypes = {
    handleClick: PropTypes.func.isRequired,
    selectedDays: PropTypes.array
}

DaysList.defaultProps = {
    selectedDays: []
}

export default DaysList



// WEBPACK FOOTER //
// ./resources/js/components/DaysList.js